import Reveal from "@/components/base/Reveal";
import { offersImage, insurancePromoImage } from "@/mocks/ppcare";

export default function OffersSection() {
  return (
    <section id="shop" className="bg-background-50 pb-16 md:pb-24">
      <div className="container">
        <div className="grid grid-cols-1 gap-7 md:grid-cols-2">
          <Reveal>
            <div className="flex h-full flex-col items-center rounded-lg border border-background-200 bg-background-100 p-8 text-center">
              <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">
                Check Our <span className="text-accent-500">Offers</span>
              </h2>
              <p className="mt-3 text-sm font-medium text-foreground-600">Coming Soon!</p>
              <a
                href="#shop"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                View Offers
              </a>
              <img
                src={offersImage}
                alt="Man holding a phone reviewing offers"
                className="mt-8 h-64 w-full object-contain"
              />
            </div>
          </Reveal>
          <Reveal delay={120}>
            <div className="flex h-full flex-col items-center rounded-lg border border-background-200 bg-background-100 p-8 text-center">
              <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">
                Accepted <span className="text-accent-500">Insurance</span>
              </h2>
              <p className="mt-3 text-sm font-medium text-foreground-600">
                We work with most major plans
              </p>
              <a
                href="#insurance"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                View Insurance
              </a>
              <img
                src={insurancePromoImage}
                alt="Accepted insurance illustration"
                className="mt-8 h-64 w-full object-contain"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}